import BgImageLeft from "../../assets/images/BgImageLeft.png"
import BgImageRight from "../../assets/images/BgImageRight.png"
import AssetLogo from "../../assets/images/Asset_Logo.png"
import { ALL_APPS } from "../../constants/dataConstant"
import ButtonElement from '../../components/ButtonElement'

const MainSection = () => {

    const handleAppClick = (link: string) => {
        window.open(link, "_blank");
    }

    return (
        <div className="w-screen h-screen flex justify-center items-center" style={{ height: 'calc(100vh - 50px)' }}>
            <div className="w-[calc(100%-40px)] h-[calc(100%-40px)] relative bg-[#1C1C1C]">
                <div className="h-full absolute left-0">
                    <img src={BgImageLeft} style={{ height: "100%" }} alt=""/>
                </div>
                <div className="h-full absolute right-0">
                    <img src={BgImageRight} style={{ height: "100%" }} alt=""/>
                </div>

                <div className="w-full h-full flex flex-col justify-center items-center">
                    <img src={AssetLogo} className="w-[173px] h-[40px]" alt="Asset money logo"/>
                    <div className="mt-6 w-[80%] font-inter text-[56px] text-[#F9D3A6] leading-[110%] text-center z-20">
                        <span className="">{`Are you the`}&nbsp;</span>
                        <span className="font-extralight italic">{`biggest`}&nbsp;</span>
                        <span className="">{`fan?`}</span>
                    </div>
                    <div className="w-[40%] mt-2 font-inter font-light text-[24px] leading-[110%] text-[#F9D3A6] text-center z-20">
                        {`Show the love towards your favourite artist and showcase your fandom.`}
                    </div>
                    <div className="mt-10 font-inter text-[36px] leading-[110%] text-[#F9D3A6] opacity-60 text-center">
                        {`Our Apps`}
                    </div>
                    <div className="mt-4 w-[80%] flex justify-center items-center">
                        <div className="flex flex-row overflow-x-auto gap-4 z-20">
                            {
                                ALL_APPS.map((app) => {
                                    return (
                                        <div key={app.appName} className="flex flex-col gap-2 items-center justify-center'">
                                            <div className="font-inter text-[18px] text-[#F9D3A6]">{app.appName}</div>
                                            <div className="relative w-[190px] h-[230px] group">
                                                <img src={app.image} className="w-full h-full object-cover" alt={app.appName}/>
                                                <div className="absolute inset-0 flex justify-center items-center bg-black bg-opacity-0 group-hover:bg-opacity-80 transition-all duration-300">
                                                    <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                                        {
                                                            app.appName === "Fanpit" ?
                                                            <p className="text-[rgba(249,211,166,1)] text-[18px]">Coming Soon</p>
                                                            :
                                                            <ButtonElement
                                                                text={app.appName}
                                                                disabled={false}
                                                                clickHandler={() => handleAppClick(app.link)}
                                                            />
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default MainSection
